/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Field_Project_Instructions_Q1_C2Inputs */



/**
* | output |
* | --- |
* | "Sales proposals and offers" |
*
* @param {Uno_Field_Project_Instructions_Q1_C2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_field_project_instructions_q1_c2 = /** @type {((inputs?: Uno_Field_Project_Instructions_Q1_C2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Field_Project_Instructions_Q1_C2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Angebote und Vertrieb")
	return /** @type {LocalizedString} */ ("Sales proposals and offers")
});